module.exports = __webpack_public_path__ + "img/icon4-1.7f624dd5.png";